export default class ImageWithHotspots {


	// Constructor
	constructor(element) {

		this.element = element;

		this.closeButtons = Array.prototype.slice.call(this.element.querySelectorAll('.section-image-with-hotspots--close'), 0);
		this.triggerButtons = Array.prototype.slice.call(this.element.querySelectorAll('.section-image-with-hotspots--trigger'), 0);
		this.panels = Array.prototype.slice.call(this.element.querySelectorAll('.section-image-with-hotspots--panel'), 0);

		this.hide = this.hide.bind(this);
		this.show = this.show.bind(this);

	}


	// Public Methods
	destroy() {
		this.disable();
		delete this.element;
		delete this.closeButtons;
		delete this.triggerButtons;
		delete this.panels;
	}
	enable() {
		this.disable();
		var i, l;
		for (i=0, l=this.closeButtons.length; i<l; i++) {
			this.closeButtons[i].addEventListener('click', this.hide);
		}
		for (i=0, l=this.triggerButtons.length; i<l; i++) {
			this.triggerButtons[i].addEventListener('click', this.show);
		}
	}
	disable() {
		var i, l;
		for (i=0, l=this.closeButtons.length; i<l; i++) {
			this.closeButtons[i].removeEventListener('click', this.hide);
			this.closeButtons[i].setAttribute('aria-expanded', 'false');
		}
		for (i=0, l=this.triggerButtons.length; i<l; i++) {
			this.triggerButtons[i].removeEventListener('click', this.show);
			this.triggerButtons[i].classList.remove('hide');
			this.triggerButtons[i].setAttribute('aria-expanded', 'false');
			this.triggerButtons[i].setAttribute('aria-hidden', 'false');
		}
		for (i=0, l=this.panels.length; i<l; i++) {
			this.panels[i].classList.remove('show');
			this.panels[i].setAttribute('aria-hidden', 'true');
		}
	}


	// Event Handlers
	hide(event) {
		event.preventDefault();
		var i, l;
		for (i=0, l=this.closeButtons.length; i<l; i++) {
			this.closeButtons[i].setAttribute('aria-expanded', 'false');
		}
		for (i=0, l=this.triggerButtons.length; i<l; i++) {
			this.triggerButtons[i].classList.remove('hide');
			this.triggerButtons[i].setAttribute('aria-expanded', 'false');
			this.triggerButtons[i].setAttribute('aria-hidden', 'false');
		}
		for (i=0, l=this.panels.length; i<l; i++) {
			this.panels[i].classList.remove('show');
			this.panels[i].setAttribute('aria-hidden', 'true');
		}
	}
	show(event) {
		event.preventDefault();
		var index = this.triggerButtons.indexOf(event.currentTarget);

		var i, l;
		for (i=0, l=this.closeButtons.length; i<l; i++) {
			if (i === index) {
				this.closeButtons[i].setAttribute('aria-expanded', 'true');
			} else {
				this.closeButtons[i].setAttribute('aria-expanded', 'false');
			}
		}
		for (i=0, l=this.triggerButtons.length; i<l; i++) {
			this.triggerButtons[i].classList.add('hide');
			this.triggerButtons[i].setAttribute('aria-hidden', 'true');
			if (i === index) {
				this.triggerButtons[i].setAttribute('aria-expanded', 'true');
			} else {
				this.triggerButtons[i].setAttribute('aria-expanded', 'false');
			}
		}
		for (i=0, l=this.panels.length; i<l; i++) {
			if (i === index) {
				this.panels[i].classList.add('show');
				this.panels[i].setAttribute('aria-hidden', 'false');
			} else {
				this.panels[i].classList.remove('show');
				this.panels[i].setAttribute('aria-hidden', 'true');
			}
		}

	}

}
